/* WALLY custom PDP zoom: fullscreen swipe carousel. Replaces Horizon's stacked zoom. */
(function () {
  'use strict';
  var main = document.querySelector('main[data-template^="product"]') || document.querySelector('[data-template^="product"]');
  if (!main) return;

  var dialog, track, counter, slides = [];

  function hiRes(src) {
    if (!src) return src;
    try { var u = new URL(src, location.origin); u.searchParams.set('width', '2048'); return u.toString(); }
    catch (e) { return src; }
  }
  function pathOf(src) { return (src || '').split('?')[0]; }

  function galleryRootFor(img) {
    return img.closest('slideshow-component') || img.closest('.product-media-list') ||
           img.closest('[class*="media-gallery"]') || img.closest('.product-media-container');
  }

  function collectImages(root) {
    var nodes = root ? root.querySelectorAll('.product-media__image, [class*="thumbnail"] img')
                     : main.querySelectorAll('.product-media__image');
    var seen = {}, out = [];
    nodes.forEach(function (img) {
      var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src');
      if (!src) return;
      var key = pathOf(src);
      if (seen[key]) return;
      seen[key] = 1;
      out.push(hiRes(src));
    });
    return out;
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'wally-zoom';
    dialog.innerHTML =
      '<button class="wally-zoom__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="wally-zoom__nav wally-zoom__nav--prev" type="button" aria-label="Previous image">&#8249;</button>' +
      '<div class="wally-zoom__track" tabindex="-1"></div>' +
      '<button class="wally-zoom__nav wally-zoom__nav--next" type="button" aria-label="Next image">&#8250;</button>' +
      '<div class="wally-zoom__counter" aria-hidden="true"></div>';
    document.body.appendChild(dialog);
    track = dialog.querySelector('.wally-zoom__track');
    counter = dialog.querySelector('.wally-zoom__counter');

    dialog.querySelector('.wally-zoom__close').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('.wally-zoom__nav--prev').addEventListener('click', function () { step(-1); });
    dialog.querySelector('.wally-zoom__nav--next').addEventListener('click', function () { step(1); });
    dialog.addEventListener('click', function (e) {
      if (e.target.classList.contains('wally-zoom__slide') || e.target === track || e.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
    dialog.addEventListener('close', function () { document.body.style.overflow = ''; track.innerHTML = ''; });
    track.addEventListener('scroll', updateCounter, { passive: true });
  }

  function index() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  function step(dir) {
    var i = Math.max(0, Math.min(slides.length - 1, index() + dir));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function updateCounter() { if (counter) counter.textContent = (index() + 1) + ' / ' + slides.length; }

  function open(images, startIndex) {
    if (!dialog) build();
    track.innerHTML = '';
    slides = images.map(function (src) {
      var slide = document.createElement('div');
      slide.className = 'wally-zoom__slide';
      var img = document.createElement('img');
      img.src = src; img.alt = ''; img.decoding = 'async';
      slide.appendChild(img);
      track.appendChild(slide);
      return slide;
    });
    dialog.classList.toggle('wally-zoom--single', images.length < 2);
    document.body.style.overflow = 'hidden';
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
    requestAnimationFrame(function () {
      track.scrollLeft = (startIndex || 0) * track.clientWidth;
      updateCounter();
    });
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest('.product-media__image');
    if (!img || img.closest('.wally-zoom')) return;
    if (img.closest('product-recommendations, .resource-list, [class*="recommendation"], .product-card, .product-card-gallery')) return;
    if (!main.contains(img)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var root = galleryRootFor(img);
    var images = collectImages(root);
    if (!images.length) return;
    var clicked = pathOf(img.currentSrc || img.src);
    var idx = 0;
    images.forEach(function (s, i) { if (pathOf(s) === clicked) idx = i; });
    open(images, idx);
  }, true);
})();
